import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { ThemeProvider } from "@/components/ThemeProvider";
import { SessionProvider } from "@/lib/auth/session";
import { RevalidateProvider } from "@/lib/loader";
import { router } from "./router";
import "./styles/globals.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <SessionProvider>
        <RevalidateProvider>
          <RouterProvider router={router} />
        </RevalidateProvider>
      </SessionProvider>
    </ThemeProvider>
  </StrictMode>,
);
